module.exports = __webpack_public_path__ + "img/wl_slider2.dc7f964e.jpg";